import {kYoutubeLink} from "../../constants/links";

export default function SystemDrawerYoutubeImage() {
    // Used in SystemAppDrawer to display ummia channel
    // YouTube link as a logo

    // BUILD
    return (
        <a href={kYoutubeLink}
           target="_blank"
           rel="noreferrer">
            <img className="h-[32px] w-auto object-contain transition-all duration-150 hover:drop-shadow-[0_0_8px_rgba(258,180,190,0.4)] cursor-pointer"
                 src="/images/SystemYoutubeLogo.png"
                 alt="YouTube" />
        </a>
    );
}